module.exports = __webpack_public_path__ + "static/img/erwima.55743f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/erwima.png
// module id = BIDC
// module chunks = 4